import {makeObservable, observable, action, runInAction} from 'mobx';
import {FIRST_LEVEL_TIME, SECONDS_PER_WORD} from '../constants';

const INITIAL_SCORE = 0;
const TIMER_STATUS_PAUSED = 'paused';
const TIMER_STATUS_RUNS = 'runs';
// const TIMER_INITIAL_TIME = 120;
const INITIAL_TIMER_STATUS = {status: TIMER_STATUS_PAUSED, seconds: 0};
const COLORS = ['#6867AC', '#A267AC', '#CE7BB0', '#FFBCD1', '#E7E0C9', '#C1CFC0', '#6B7AA1', '#11324D'];
let colorIdx = 0;

class WordSearchGameState {
    score = INITIAL_SCORE;
    timer = INITIAL_TIMER_STATUS;
    isTouchDevice = 'ontouchstart' in document.documentElement;
    wordColor = COLORS[colorIdx];
    level = 1;

    constructor() {
        this.timerInterval;

        makeObservable(this, {
            // Score
            score: observable,
            addPoint: action,
            // Timer
            timer: observable,
            startTimer: action,
            pauseTimer: action,
            // Reset
            reset: action,
            // Touch Device
            isTouchDevice: observable,
            // Current word color
            wordColor: observable,
            pickNextWordColor: action,
            // Level
            level: observable,
            setNewLevel: action,
            setNextLevel: action,
        });
    }

    addPoint() {
        this.score++;
    }

    startTimer() {
        this.timer.seconds = getLevelSeconds(this.level);
        this.timer.status = TIMER_STATUS_RUNS;
        this.timerInterval = setInterval(() => {
            runInAction(this.tickTimer.bind(this));
        }, 1000);
    }

    pauseTimer() {
        this.timer.status = TIMER_STATUS_PAUSED;
        clearInterval(this.timerInterval);
        return true;
    }

    tickTimer() {
        this.timer.seconds = this.timer.seconds - 1;
    }

    reset() {
        this.score = INITIAL_SCORE;
        this.pauseTimer();
        this.timer = {status: TIMER_STATUS_PAUSED, seconds: getLevelSeconds(this.level)};
    }

    pickNextWordColor() {
        if (++colorIdx === COLORS.length) {
            colorIdx = 0;
        }
        this.wordColor = COLORS[colorIdx];
    }

    setNewLevel(newLevel) {
        this.level = parseInt(newLevel, 10);
        localStorage.setItem('level', newLevel);
        this.timer.seconds = getLevelSeconds(this.level);
        return this.level;
    }

    setNextLevel() {
        this.level++;
        localStorage.setItem('level', this.level);
        this.timer.seconds = getLevelSeconds(this.level);
        return this.level;
    }
}

const getLevelSeconds = (level) => {
    let result = FIRST_LEVEL_TIME;
    if (level > 1) {
        return FIRST_LEVEL_TIME + (level - 1) * SECONDS_PER_WORD;
    }
    return result;
};

export default WordSearchGameState;
